"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const diacritics_1 = require("diacritics");
const libphonenumber_js_1 = require("libphonenumber-js");
const _ = __importStar(require("lodash"));
const Logger_1 = __importDefault(require("./Logger"));
const ParseProvider_1 = __importDefault(require("./ParseProvider"));
const Parse = ParseProvider_1.default.ParseInstance;
const moment = require("moment");
/**
 * Durée de prise en charge (éstimée) en minutes pour une mission allongée.
 * Ceci comprend: le temps de PEC et de dépose du patient
 */
exports.FareEstimatedPickupTimeAmbulance = 40;
/**
 * Durée de prise en charge (éstimée) en minutes pour une mission assise.
 * Ceci comprend: le temps de PEC et de dépose du patient
 */
exports.FareEstimatedPickupTimeSeated = 25;
/**
 * Les estimations sont arrondies aux X minutes les plus proches.
 * Par exemple: si la constante vaut 5:
 * - Si le départ est estimé à 12h24, on arrondit à 12h20 (arrondis par le bas)
 * - Si l'arrivée est estimée à 12h21, on arrondit à 12h25 (arrondis par le haut)
 */
exports.FareEstimatedPickupTimeRoundToNextMinutes = 5;
class Utils {
    static nearestPastMinutes(interval, date) {
        const someMoment = moment.isMoment(date) ? date : moment(date);
        const roundedMinutes = Math.floor(someMoment.minute() / interval) * interval;
        return someMoment.clone().minute(roundedMinutes).second(0);
    }
    static nearestFutureMinutes(interval, date) {
        const someMoment = moment.isMoment(date) ? date : moment(date);
        const roundedMinutes = Math.ceil(someMoment.minute() / interval) * interval;
        return someMoment.clone().minute(roundedMinutes).second(0);
    }
    static distance(from, to) {
        let parseGeoFrom, parseGeoTo;
        if (from instanceof Parse.GeoPoint) {
            parseGeoFrom = from;
        }
        else {
            parseGeoFrom = new Parse.GeoPoint(from.latitude, from.longitude);
        }
        if (to instanceof Parse.GeoPoint) {
            parseGeoTo = to;
        }
        else {
            parseGeoTo = new Parse.GeoPoint(to.latitude, to.longitude);
        }
        return parseGeoFrom.kilometersTo(parseGeoTo);
    }
    static buildMatchingRegex(str) {
        const replacements = {};
        replacements['e'] = ['é', 'è', 'ê', 'ë'];
        replacements['a'] = ['â', 'ä', 'à'];
        replacements['E'] = ['É', 'È', 'Ê', 'Ë'];
        replacements['A'] = ['Â', 'Ä', 'À'];
        let cleanedName = Utils.removeDiacriticsFrom(str.trim());
        cleanedName = _.escapeRegExp(cleanedName);
        let regex = '';
        for (let i = 0; i < cleanedName.length; i++) {
            const c = cleanedName[i];
            if (replacements[c]) {
                let reps = replacements[c];
                reps.push(c);
                regex += '(' + reps.join('|') + ')';
            }
            else {
                regex += c;
            }
        }
        return new RegExp(regex, 'i');
    }
    /**
     * Supprime la diacritique (les accents) d'une chaine de caratères. Très utiles pour la recherche fulltext :)
     * @param str
     */
    static removeDiacriticsFrom(str) {
        return diacritics_1.remove(str);
    }
    static parseGeoPointFrom(point) {
        if (point instanceof ParseProvider_1.default.ParseInstance.GeoPoint) {
            return point;
        }
        else if (point) {
            return new ParseProvider_1.default.ParseInstance.GeoPoint(point.latitude, point.longitude);
        }
        return undefined;
    }
    static objectQueryJsonFromQueryString(query, dateFields = [], integerFields = [], fieldsToIgnore = []) {
        let pairs = query.split('&');
        if (pairs[0][0] === '?') {
            pairs[0] = pairs[0].slice(1);
        }
        const dateFormat = 'YYYYMMDDHHmm';
        let result = {};
        pairs.forEach((p) => {
            const pair = p.split('=');
            const key = decodeURIComponent(pair[0]);
            const stringValue = decodeURIComponent(pair[1] || '');
            if (fieldsToIgnore.indexOf(key) === -1) {
                if (dateFields.indexOf(key) !== -1) {
                    result[key] = moment(stringValue, dateFormat).toDate();
                }
                else if (key.endsWith('[]')) {
                    const realKey = key.substr(0, key.length - 2);
                    let keyArray = result[realKey] ? result[realKey] : [];
                    if (integerFields.indexOf(realKey) !== -1) {
                        keyArray.push(parseInt(stringValue));
                    }
                    else {
                        keyArray.push(stringValue);
                    }
                    result[realKey] = keyArray;
                }
                else if (integerFields.indexOf(key) !== -1) {
                    result[key] = parseInt(stringValue);
                }
                else {
                    result[key] = stringValue;
                }
            }
        });
        return result;
    }
    static objectQueryJsonToQueryString(query) {
        const result = {};
        const dateFormat = 'YYYYMMDDHHmm';
        for (let key in query) {
            if (query[key] instanceof Date) {
                result[key] = moment(query[key]).format(dateFormat);
            }
            else if (query[key] !== undefined) {
                result[key] = query[key];
            }
        }
        return Object.keys(result)
            .map((k) => {
            const value = result[k];
            if (Array.isArray(value)) {
                return value
                    .map((v) => {
                    return encodeURIComponent(k + '[]') + '=' + encodeURIComponent(v);
                })
                    .join('&');
            }
            else {
                return encodeURIComponent(k) + '=' + encodeURIComponent(result[k]);
            }
        })
            .join('&');
    }
    static validateTelephone(telephone) {
        let parseResult = null;
        try {
            parseResult = libphonenumber_js_1.parse(telephone, 'FR');
        }
        catch (e) {
            Logger_1.default.warn(`Error parsing ${telephone} as phone number`, e);
        }
        return parseResult !== null && Object.keys(parseResult).length > 0 && libphonenumber_js_1.isValidNumber(parseResult);
    }
}
exports.default = Utils;
//# sourceMappingURL=Utils.js.map